/*
 * @Description: 数据分析所有伪代码实例方法汇总
 * @Author: shenah
 * @Date: 2023-04-11 17:04:06
 * @LastEditors: zhanghang
 * @LastEditTime: 2024-07-18 10:14:21
 */
import commonEvent from "./commonEvent";
import generalTableEvent from "./generalTableEvent";
import onlyOneEvent from "./onlyOneEvent";

export default {
  methods: {
    ...commonEvent,
    ...generalTableEvent,
    ...onlyOneEvent,
    // 额外的刷新,因为有些改变data不能触发刷新还需要调用别的方法
    extraSpecialRender(obj) {
      if (typeof this.changeDataRender === "function") {
        // 结构监测、排名轮播表、字符云3、icon评分
        if (
          [
            "dsf-dataview-keytrades",
            "dsf-dataview-business-constractor-alansi",
            "data-view-scroll-ranking-board",
            "rune-clouds",
            "dsf-dataview-icon-rate",
          ].indexOf(this.componentRef) > -1
        ) {
          this.changeDataRender(this.data);
          // 水位图、数字翻牌器
        } else if (
          ["water-pond-level-wrap", "data-view-scroll-digital"].indexOf(
            this.componentRef
          ) > -1
        ) {
          this.changeDataRender(obj);
        }
      }
    },
  },
};
